import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TagInputModule } from "ngx-chips";

import { MaterialAppModule } from "../../../ngmaterial.module";

import * as user from ".";

import { CommonModule } from "../../../common/common.module";

@NgModule({
	imports: [
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		CommonModule,
		TagInputModule,
		MaterialAppModule
	],
	declarations: [
		user.UserWizardEditComponent
	]
})
export class UserWizardModule { }
